import "./multi-collections-collection";

class MultiCollections extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("tab-component:tab-selected", this._onTabSelected);
  }

  disconnectedCallback() {
    this.removeEventListener("tab-component:tab-selected", this._onTabSelected);
  }

  _onTabSelected = (e) => {
    const { tab } = e.detail;

    this.querySelectorAll("[data-show-for]").forEach((image) => {
      image.classList.toggle("is-active", image.dataset.showFor === tab.id);
    });
  };
}

if (!customElements.get("multi-collections")) {
  customElements.define("multi-collections", MultiCollections);
}
